module.exports = __webpack_public_path__ + "img/personas.08393d6a.svg";